export const abmUsers = {
    read(options) {
      return $.getJSON(AdminRoutes.adminAPIV3ABMUsersPath(options));
    },

    retire(userIds) {
      return $.ajax({
          method: 'POST',
          url: AdminRoutes.retireAdminAPIV3ABMUsersPath(),
          data: { user_ids: userIds },
          dataType: 'text'
      });
    },
};
